import { CS } from "../../../../base/utils/styler";

export const rateTrStyle: CS = {
    width: '100%',
    position: 'relative',
}

export const rateTrToCadStyle: CS = {
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
}